import { ref } from 'vue';
import { useVehicleTypes } from './useVehicleTypes';
import { useVehicleDetails } from './useVehicleDetails';
const activeTab = ref(1);
export function useSearchTabs() {
    const { clearVehicleTypes } = useVehicleTypes();
    const { clearLicencePlate } = useVehicleDetails();
    function setActiveTab(tab) {
        activeTab.value = tab;
        // Clear all vehicle data when changing active panel
        clearVehicleTypes();
        clearLicencePlate();
    }
    return {
        activeTab,
        setActiveTab
    };
}
